export const sliceCaller = Array.prototype.slice;
export const slice = Function.prototype.call.bind(sliceCaller);
export default slice;
